import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="bg-navy text-white pt-12 pb-20 px-4 md:px-8 overflow-hidden relative" data-id="element-63">
      {/* Background subtle accent */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-10 pointer-events-none" data-id="element-64">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-gold blur-[120px]" data-id="element-65"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-66">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-67">
          {/* Left Column: Copy */}
          <motion.div className="flex-1 text-center lg:text-left" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-68">
            <motion.div className="inline-block bg-red text-white text-xs md:text-sm font-bold tracking-wider py-1.5 px-4 rounded-full mb-6 uppercase" initial={{
            opacity: 0,
            scale: 0.8
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: 0.3,
            duration: 0.5
          }} data-id="element-69">
              Limited Time Offer
            </motion.div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-70">
              Lower Your House Payment in 90 Days:{' '}
              <span className="text-gold" data-id="element-71">
                The Ultimate Property Tax Exterminator
              </span>
            </h1>

            <h2 className="text-xl md:text-2xl text-gray-300 font-light leading-relaxed mb-8" data-id="element-72">
              Stop overpaying due to County errors. Recover up to{' '}
              <strong className="text-gold font-bold" data-id="element-73">$2,000 annually</strong>{' '}
              on your mortgage without refinancing and without expensive
              lawyers.
            </h2>

            <ul className="space-y-4 mb-10 text-left inline-block lg:block" data-id="element-74">
              {['100% Legal — Your Constitutional Right', 'No Attorney Needed', 'Works in All 50 States'].map((item, i) => <motion.li key={i} className="flex items-center gap-3 text-lg md:text-xl" initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: 0.5 + i * 0.1,
              duration: 0.5
            }} data-id="element-75">
                  <CheckCircle2 className="text-green w-6 h-6 flex-shrink-0" data-id="element-76" />
                  <span data-id="element-77">{item}</span>
                </motion.li>)}
            </ul>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.9,
            duration: 0.5
          }} data-id="element-78">
              <CTAButton className="lg:items-start" subtext="Secure checkout. Instant PDF access delivered to your email." data-id="element-79" />
            </motion.div>
          </motion.div>

          {/* Right Column: Image */}
          <motion.div className="flex-1 w-full max-w-md lg:max-w-none perspective-1000" initial={{
          opacity: 0,
          scale: 0.9,
          rotateY: 15
        }} animate={{
          opacity: 1,
          scale: 1,
          rotateY: -5
        }} transition={{
          delay: 0.4,
          duration: 1,
          type: 'spring'
        }} style={{
          perspective: '1000px'
        }} data-id="element-80">
            <motion.div animate={{
            y: [0, -10, 0]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="relative" data-id="element-81">
              <div className="absolute inset-0 bg-gold rounded-xl blur-2xl opacity-20 transform scale-95" data-id="element-82"></div>
              <img src="https://cdn.magicpatterns.com/uploads/9HJKBugXqnyyqaj3sf4ns8/Property_Tax_Slayer_English.png" alt="Property Tax Slayer Digital Guide" className="w-full h-auto drop-shadow-2xl rounded-lg relative z-10" style={{
              transform: 'rotateY(-5deg) rotateX(2deg)'
            }} data-id="element-83" />
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}